"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALLOWED_EDGEAI_SOURCES = void 0;
var ALLOWED_EDGEAI_SOURCES = exports.ALLOWED_EDGEAI_SOURCES = ["Power_BI", "Tableau", "Domo", "SAP", "Epic", "Grafana", "Splunk", "Servicenow", "Web_Browser", "Splunk", "Excel"];